export default __webpack_public_path__ + "static/media/DT1.f6b69cc3.jpg";